import { Platform } from '@angular/cdk/platform';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { LyTheme2, ThemeVariables } from '@alyle/ui';
import { ImgCropperConfig, ImgCropperEvent, LyResizingCroppingImages, ImgCropperErrorEvent } from '@alyle/ui/resizing-cropping-images';

const styles = ({
  actions: {
    display: 'flex'
  },
  cropping: {
    maxWidth: '400px',
    height: '250px'
  },
  flex: {
    flex: 1
  },
  range: {
    textAlign: 'center',
    maxWidth: '400px',
    margin: '14px'
  }
});

export interface DialogData {
  image: any;
}
@Component({
  selector: 'meu-app-change-image',
  templateUrl: './app-change-image.component.html',
  styleUrls: ['./app-change-image.component.scss']
})
export class AppChangeImageComponent implements OnInit {
  //   @ViewChild(LyImageCropper,{static: false}) cropper: LyImageCropper;

  //  image: any;
  Title_Modal: string = 'Chọn ảnh hồ sơ nhân sự';


  constructor(
    public dialogRef: MatDialogRef<AppChangeImageComponent>,
    private theme: LyTheme2,
    private _platform: Platform,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private changeDetector: ChangeDetectorRef
  ) { }
  currentAvatar = null;
  classes = this.theme.addStyleSheet(styles);
  croppedImage?: string;
  result: string;
  scale: number;
  //image release//
  minScale: any;
  ready: any;
  //end
  //imgURL: string = 'assets/media/users/default.jpg';
  @ViewChild("cropping", { static: false }) cropper: LyResizingCroppingImages;
  myConfig: ImgCropperConfig = {

    //autoCrop: true, // Default `false`
    width: 200, // Default `250`
    height: 200, // Default `200`
    fill: '#ff2997', // Default transparent if type = png else #000
    type: 'image/png', // Or you can also use `image/jpeg`

  }


  ngOnInit() {
    this.currentAvatar = this.data.image;
  }
  ngAfterViewInit() {

    if (this._platform.isBrowser) {
      const config = {
        scale: 0,
        position: {
          x: 476.5,
          y: 476.5
        }
      };
      this.cropper.setImageUrl(
        this.currentAvatar,
        () => {
          this.cropper.setScale(config.scale, true);
          this.cropper.updatePosition(config.position.x, config.position.y);
          this.cropper.center();
          this.cropper.fit();
        }
      );
    }
    var _this = this;
    setTimeout(() => {
      _this.cropper.center();
      _this.cropper.fit();
    }, 150);
  }
  onCropped(e: ImgCropperEvent) {
    this.data.image = e;
    this.croppedImage = e.dataURL;
    this.dialogRef.close({ data: this.croppedImage });;
  }
  onLoaded(e: ImgCropperEvent) {
    // let center = document.getElementById("center_btn");
    // center.addEventListener('click', e => {
    // });
  }
  onerror(e: ImgCropperErrorEvent) {
  }
  onInputSliderChange(e) {

    this.scale = e.value;
  }
}
